export default __webpack_public_path__ + "static/media/e1946c7d8ced7ba0.02e9763e6606d1b20b0b93f1dfc568b3.svg";